// src/data/servicesData.js
// This file contains comprehensive data about all services offered by AMV Law

const servicesData = {
  'criminal-litigation': {
    id: 'criminal-litigation',
    title: 'Criminal Litigation',
    description: 'Comprehensive legal defense and advocacy in all criminal matters across courts and investigative agencies.',
    fullDescription: 'The firm has a robust Criminal Litigation Practice, driven by a commitment to protect the rights, liberty, and reputation of individuals and corporations entangled in criminal proceedings. We offer comprehensive legal representation across the full spectrum of criminal law, from preventive advisory and investigation support to vigorous trial advocacy and appellate litigation.',
    approach: 'Our team of seasoned criminal law professionals represents clients across all judicial forums, including the Supreme Court of India, High Courts, Sessions and District Courts, and before a wide range of investigative and adjudicating authorities such as the CBI, ED, EOW, SFIO, Police, and Magistrates.',
    keyAreas: [
      'Constitutional & Statutory Offences (Prevention of Money Laundering Act, Prevention of Corruption Act, NDPS Act, etc.)',
      'Violent & General Offences (assault, homicide, attempt to murder, theft, criminal breach of trust, etc.)',
      'Cybercrime & Technology-Related Offences (data theft, hacking, identity fraud, etc.)',
      'Medical Negligence & Professional Misconduct',
      'Cheque Bounce & Financial Fraud (Section 138 of the Negotiable Instruments Act)',
      'Sexual Offences & POCSO (Protection of Children from Sexual Offences Act)',
      'Matrimonial Criminal Litigation (Section 498A & Dowry Harassment)'
    ],
    recentCases: [
      'Successfully obtained anticipatory bail for a businessman facing allegations under the PMLA Act',
      'Secured discharge for a corporate executive in a high-profile fraud case',
      'Successfully defended a client against cybercrime allegations with comprehensive digital evidence analysis'
    ],
    icon: 'justice-scale'
  },
  'family-matrimonial': {
    id: 'family-matrimonial',
    title: 'Family & Matrimonial Law',
    description: 'Compassionate, discreet, and expert legal counsel in all areas of Family and Matrimonial Law.',
    fullDescription: 'We offer compassionate, discreet, and expert legal counsel in all areas of Family and Matrimonial Law. As a boutique firm known for its personalized approach and legal precision, we understand that family disputes are not only legally complex but also deeply personal. Our practice is designed to support clients through these emotionally challenging times with sensitivity, clarity, and strategic guidance.',
    approach: 'Our lawyers are experienced in appearing before Family Courts, District and Sessions Courts, High Courts, and the Hon\'ble Supreme Court of India, as well as participating in mediations, conciliations, and arbitration when required. AMV Law is particularly adept at handling high-conflict matrimonial disputes, cross-jurisdictional family matters, and cases involving substantial financial and custodial stakes.',
    keyAreas: [
      'Divorce and Judicial Separation',
      'Child Custody and Visitation Rights',
      'Maintenance and Alimony Claims',
      'Domestic Violence Matters',
      'Guardianship Proceedings',
      'Succession and Inheritance Disputes',
      'Wills and Estate Planning',
      'Mediation and Alternative Dispute Resolution'
    ],
    recentCases: [
      'Successfully secured favorable custody arrangements in a high-conflict international divorce case',
      'Negotiated equitable settlement in a complex matrimonial property dispute',
      'Obtained comprehensive maintenance order for a spouse with limited financial resources'
    ],
    icon: 'family'
  },
  'transactional-contract': {
    id: 'transactional-contract',
    title: 'Transactional & Contract Management',
    description: 'Full range of legal services for commercial transactions and contract management to protect your business interests.',
    fullDescription: 'The firm offers a full range of legal services relating to commercial transactions and contract management, designed to protect your business and ensure successful outcomes. We provide strategic and timely legal counsel to ensure your transactions are efficient and your contracts are legally sound.',
    approach: 'Our approach combines legal expertise with business acumen to deliver practical solutions that align with our clients\' commercial objectives. We work closely with businesses of all sizes to structure transactions, draft and negotiate agreements, and implement contract management systems that enhance operational efficiency and minimize legal risks.',
    keyAreas: [
      'Comprehensive due diligence investigations and risk assessments',
      'Drafting, reviewing, and negotiating commercial contracts (sales, service, distribution agreements)',
      'Legal support for mergers, acquisitions, and restructuring transactions',
      'Structuring and negotiating joint venture and partnership agreements',
      'Implementing and managing contract lifecycle management systems',
      'Representing clients in contract disputes and litigation'
    ],
    recentCases: [
      'Successfully structured and documented a complex cross-border joint venture',
      'Implemented a comprehensive contract management system for a growing technology company',
      'Negotiated favorable settlement in a high-value commercial contract dispute'
    ],
    icon: 'document'
  },
  'taxation': {
    id: 'taxation',
    title: 'Taxation Laws',
    description: 'Expert guidance on direct and indirect taxation matters, compliance, and dispute resolution.',
    fullDescription: 'The firm\'s taxation team is distinguished by its profound capacity to architect bespoke solutions for complex transactions and reorganizations, taxation agreements, and permanent establishment strategy. We are skilled in tax controversy resolution, providing comparative approach for strategic investment entry and delivering holistic advice on direct and indirect taxation.',
    approach: 'We pride ourselves on delivering client-focused, legally robust, and efficient guidance to Indian businesses, establishing a model of effective practice for tax advisory services. Our approach combines deep technical knowledge with practical business acumen to navigate the complex taxation landscape effectively.',
    keyAreas: [
      'Direct tax planning and compliance',
      'Indirect tax matters including GST',
      'International taxation and cross-border transactions',
      'Tax dispute resolution and litigation',
      'Tax implications of corporate restructuring',
      'Tax-efficient investment structures',
      'Tax compliance reviews and assessments'
    ],
    recentCases: [
      'Successfully represented a multinational corporation in a significant transfer pricing dispute',
      'Developed tax-efficient structure for a major cross-border acquisition',
      'Secured favorable resolution in a complex GST refund matter'
    ],
    icon: 'calculation'
  },
  'real-estate-property': {
    id: 'real-estate-property',
    title: 'Real Estate & Property Litigation',
    description: 'Resolution of complex property disputes, RERA matters, and real estate transactions.',
    fullDescription: 'The firm offers holistic legal solutions across the full spectrum of real estate and property-related disputes. Our practice is built on a deep understanding of the legal, commercial, and regulatory frameworks governing the Indian real estate sector—one of the most dynamic and closely regulated areas of the economy.',
    approach: 'We represent a broad range of clients including developers, homebuyers, investors (domestic and foreign), lenders, corporate houses, landlords, tenants, contractors, and private individuals, offering strategic guidance and strong advocacy in both contentious and preventive matters. Our litigation team appears regularly before the Supreme Court of India, High Courts, District and Civil Courts, Consumer Commissions, Real Estate Regulatory Authorities (RERA), Real Estate Appellate Tribunals, and other competent forums.',
    keyAreas: [
      'Delayed possession and construction defect disputes',
      'Title disputes and property ownership conflicts',
      'Land acquisition matters',
      'RERA compliance and litigation',
      'Landlord-tenant disputes',
      'Family property disputes and partition suits',
      'Real estate insolvency matters',
      'Property-related criminal matters'
    ],
    recentCases: [
      'Successfully represented a group of homebuyers in securing compensation for delayed possession',
      'Obtained favorable judgment in a complex ancestral property dispute',
      'Secured relief for a developer in a RERA regulatory matter'
    ],
    icon: 'building'
  },
  'posh-compliance': {
    id: 'posh-compliance',
    title: 'POSH Compliance',
    description: 'Comprehensive solutions for workplace harassment prevention, investigation, and compliance.',
    fullDescription: 'The firm offers a full spectrum of services designed to ensure organization\'s adherence to the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013. We provide expert guidance on developing and implementing POSH policies, establishing Internal Committees, conducting investigations, providing legal representation, delivering training programs, and conducting compliance audits.',
    approach: 'We are committed to helping organizations create a safe, respectful, and legally sound workplace through practical, tailored solutions that address the specific needs and challenges of each client. Our approach combines legal expertise with sensitivity to the complex interpersonal dynamics involved in workplace harassment issues.',
    keyAreas: [
      'Development and implementation of robust POSH policies',
      'Facilitation of Internal Committee establishment and training',
      'Thorough and impartial investigation of complaints',
      'Legal representation in POSH-related litigation',
      'Impactful training and awareness programs',
      'Detailed compliance audits',
      'Advisory on preventive measures and best practices'
    ],
    recentCases: [
      'Successfully conducted a comprehensive POSH audit for a multinational corporation',
      'Provided expert guidance in resolving a complex workplace harassment complaint',
      'Developed and implemented customized POSH training programs for a large corporate client'
    ],
    icon: 'shield'
  },
  'labour-employment': {
    id: 'labour-employment',
    title: 'Labour & Employment Laws',
    description: 'Advisory and litigation services for workforce management and employment relations.',
    fullDescription: 'The firm offers a full range of legal services relating to Indian Labour Law, designed to protect your business and ensure compliance. We provide strategic and timely legal counsel to help you navigate the dynamic landscape of Indian labour laws, balancing regulatory requirements with operational needs.',
    approach: 'Our approach is to work proactively with clients to establish compliant employment practices while maintaining operational flexibility. When disputes arise, we represent clients vigorously before various forums, seeking efficient and favorable resolutions that align with business objectives.',
    keyAreas: [
      'Drafting and reviewing employment agreements, handbooks, and policies',
      'Advisory services on compliance with various labour legislations',
      'Representation in industrial disputes, conciliation, and arbitration',
      'Litigation before labour tribunals, High Courts, and the Supreme Court',
      'Advising on restructuring, retrenchment, and closure procedures',
      'Labour law due diligence for corporate transactions'
    ],
    recentCases: [
      'Successfully defended an employer in a complex wrongful termination case',
      'Advised a multinational company on restructuring its workforce while ensuring legal compliance',
      'Represented a client in industrial dispute conciliation, achieving a mutually beneficial settlement'
    ],
    icon: 'briefcase'
  },
  'intellectual-property': {
    id: 'intellectual-property',
    title: 'Intellectual Property Rights',
    description: 'Protection and enforcement of trademarks, patents, copyrights, and designs.',
    fullDescription: 'The firm provides expert legal services across all aspects of Intellectual Property Law, including registration, enforcement, and litigation. We help clients protect and monetize their intellectual property assets while navigating the complex legal landscape of IP rights and regulations.',
    approach: 'Our approach combines technical expertise with strategic thinking to develop tailored IP solutions that align with our clients\' business objectives. We work with creators, innovators, and businesses of all sizes to secure, manage, and enforce their intellectual property rights effectively.',
    keyAreas: [
      'Trademark clearance searches, registration, and opposition proceedings',
      'Copyright registration, licensing, and infringement litigation',
      'Patent drafting, prosecution, and litigation, including infringement and validity challenges',
      'Design registration and enforcement actions',
      'Representation in IP disputes before courts and tribunals',
      'Drafting and negotiating IP licensing and technology transfer agreements'
    ],
    recentCases: [
      'Successfully secured trademark registration for a new brand in a crowded market segment',
      'Represented a content creator in a significant copyright infringement case',
      'Negotiated a favorable licensing agreement for patented technology'
    ],
    icon: 'copyright'
  },
  'consumer-disputes': {
    id: 'consumer-disputes',
    title: 'Consumer Disputes',
    description: 'Protection of consumer rights and defense against unfair trade practices across forums.',
    fullDescription: 'The firm is deeply committed to the protection and enforcement of consumer rights. In an increasingly complex marketplace, where consumers frequently interact with a broad spectrum of goods and services, our team provides strategic, effective, and nuanced legal counsel to both individual consumers and corporate entities navigating consumer-related disputes.',
    approach: 'At AMV Law, we combine a comprehensive understanding of this legal regime with practical experience to deliver bespoke legal solutions tailored to the specific needs of each client. We represent our clients robustly before all relevant fora—including the District, State, and National Consumer Disputes Redressal Commissions—as well as in appellate proceedings before the High Courts and the Supreme Court of India.',
    keyAreas: [
      'Deficiency in service claims',
      'Defective product complaints',
      'Unfair trade practice allegations',
      'Misleading advertisement cases',
      'Product liability matters',
      'Sector-specific consumer disputes (real estate, retail, healthcare, insurance, etc.)',
      'Class action consumer litigation'
    ],
    recentCases: [
      'Successfully represented a consumer in securing substantial compensation for a defective product',
      'Defended a service provider against unsubstantiated claims of service deficiency',
      'Obtained favorable settlement in a complex real estate consumer dispute'
    ],
    icon: 'shopping-bag'
  },
  'civil-commercial': {
    id: 'civil-commercial',
    title: 'Civil & Commercial Litigation',
    description: 'Strategic advocacy in business disputes, contractual matters, and civil proceedings.',
    fullDescription: 'The firm offers sophisticated and strategic legal representation in civil and commercial litigation, ensuring that disputes are resolved efficiently while safeguarding our clients\' interests. Our approach is rooted in precision, commercial pragmatism, and unwavering advocacy, making us a trusted partner in high-stakes litigation.',
    approach: 'With an in-depth understanding of the Civil Procedure Code (CPC) and other governing statutes, our litigators provide end-to-end assistance—from drafting pleadings, securing injunctions, and filing appeals to representing clients before courts, tribunals, and regulatory authorities. We are well-versed in handling complex, multi-jurisdictional disputes and cross-border commercial conflicts, ensuring seamless legal strategies tailored to our clients\' specific needs.',
    keyAreas: [
      'Contract disputes and breach of contractual obligations',
      'Shareholder and partnership disputes',
      'Commercial fraud and misrepresentation',
      'Debt recovery and enforcement of security interests',
      'Insolvency and bankruptcy proceedings',
      'Specific performance and injunction matters',
      'Alternative dispute resolution (arbitration, mediation, conciliation)'
    ],
    recentCases: [
      'Successfully represented a client in a high-value breach of contract dispute',
      'Secured favorable settlement in a complex shareholder dispute',
      'Obtained interim relief in a urgent commercial injunction matter'
    ],
    icon: 'gavel'
  },
  'white-collar-crime': {
    id: 'white-collar-crime',
    title: 'White-Collar Crime & Economic Offences',
    description: 'Strategic defense in matters involving financial crimes, regulatory investigations, and corporate misconduct.',
    fullDescription: 'Our specialized White-Collar Crime practice delivers comprehensive legal support to individuals and corporations facing allegations of financial misconduct. We provide strategically sound guidance through the complex terrain of economic offence investigations and prosecutions.',
    approach: 'We combine deep legal expertise with investigative acumen to build robust defense strategies. Our team works closely with forensic accountants and industry specialists to analyze complex financial evidence and challenge prosecutorial narratives effectively.',
    keyAreas: [
      'Securities fraud and insider trading',
      'Money laundering and PMLA compliance',
      'Corruption and bribery allegations',
      'Tax evasion and fraud',
      'Corporate fraud and embezzlement',
      'Regulatory investigations',
      'Economic offence prevention counsel'
    ],
    recentCases: [
      'Successfully defended a corporate executive against allegations of securities fraud',
      'Secured discharge for company directors in a multi-crore banking fraud case',
      'Obtained favorable settlement in a high-profile money laundering investigation'
    ],
    icon: 'briefcase'
  },
  'arbitration': {
    id: 'arbitration',
    title: 'Arbitration',
    description: 'Expert representation in domestic and international arbitrations across diverse industry sectors.',
    fullDescription: 'Our arbitration practice delivers tailored dispute resolution strategies for complex commercial conflicts. With expertise in both institutional and ad-hoc arbitration proceedings, we guide clients through every stage of the arbitration process.',
    approach: 'We take a practical, business-oriented approach to arbitration, balancing legal strategy with commercial objectives. Our team has represented clients before major arbitral institutions and in ad-hoc proceedings across various sectors including construction, energy, infrastructure, and commercial contracts.',
    keyAreas: [
      'Domestic arbitration under Indian Arbitration Act',
      'International commercial arbitration',
      'Investment treaty arbitration',
      'Arbitration agreement drafting and review',
      'Arbitrator selection and challenge procedures',
      'Enforcement of arbitral awards',
      'Arbitration-related litigation and court proceedings'
    ],
    recentCases: [
      'Successfully represented an infrastructure company in a ₹500 crore construction dispute',
      'Secured favorable award in a joint venture dispute in the renewable energy sector',
      'Successfully enforced an international arbitration award through Indian courts'
    ],
    icon: 'balance-scale'
  },
  'banking-finance': {
    id: 'banking-finance',
    title: 'Banking & Finance',
    description: 'Specialized representation in DRT matters, loan restructuring, and banking disputes.',
    fullDescription: 'Our Banking & Finance practice provides comprehensive legal services to financial institutions, corporate borrowers, and individual clients navigating the complex landscape of banking regulations and financial disputes in India. We combine sector-specific expertise with litigation excellence to deliver effective solutions.',
    approach: 'We offer strategic counsel on regulatory compliance, transaction structuring, and dispute resolution, working closely with clients to understand their specific needs and objectives. Our team has extensive experience representing clients before Debt Recovery Tribunals, DRATs, NCLT, High Courts, and the Supreme Court of India.',
    keyAreas: [
      'Debt Recovery Tribunal (DRT) proceedings',
      'Securitisation and SARFAESI Act matters',
      'Loan restructuring and debt settlements',
      'Banking fraud allegations and defense',
      'Regulatory compliance advisory',
      'Recovery proceedings and enforcement of security',
      'Banking-related arbitration and litigation'
    ],
    recentCases: [
      'Successfully represented a corporate borrower in restructuring a significant debt',
      'Obtained favorable settlement in a complex banking dispute',
      'Secured relief for a client in SARFAESI enforcement proceedings'
    ],
    icon: 'bank'
  }
};

export default servicesData;